export default {
  usd: {
    code: 'usd',
    sign: '$',
  },
  eur: {
    code: 'eur',
    sign: '€',
  },
};



// WEBPACK FOOTER //
// ./src/models/CurrenciesTypes.js